<div class="modal-header" *ngIf="header">
  <h4 class="modal-title">
    {{ 'ATTACHMENTS' | translate }}
    <span class="brown">{{ selectedAccount }}</span>
    <span *ngIf="attachment.length" class="badge badge-pill badge-warning">{{attachment.length}}</span>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="row">

    <!-- ========================= -->
    <!-- Upload card -->
    <!-- ========================= -->

    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4" *ngIf="uploadFrom">

      <div class="card">

        <div class="card-header">

          <!-- Select file -->
          <a *ngIf="!selectedFile && !uploading" class="btn btn-primary text-white" (click)="filebtn.click()">

            {{ 'FILE_BROWSER' | translate }}

            <input #filebtn hidden type="file" (change)="onFileSelected($event)" />

          </a>


          <!-- Remove selected file -->
          <a *ngIf="selectedFile && !uploading" class="btn btn-outline-danger text-danger" (click)="clear()">

            <i class="fa fa-trash-o fa-lg"></i>

          </a>


          <!-- Upload -->
          <a *ngIf="selectedFile && !uploading" class="btn btn-outline-primary text-primary" (click)="send()">

            <i class="fa fa-upload fa-lg"></i>

          </a>


          <!-- Uploading -->
          <span *ngIf="uploading" class="text-primary ml-2">

            {{ uploadProgress }}%

          </span>

        </div>


        <div class="card-body">

          <!-- ========================= -->
          <!-- Drop zone -->
          <!-- ========================= -->

          <div *ngIf="!selectedFile" class="well my-drop-zone" [ngClass]="{
              'nv-file-over': hasBaseDropZoneOver
            }" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)">

            <span>
              {{ 'DROP_ZONE' | translate }}
            </span>

          </div>


          <!-- ========================= -->
          <!-- Selected file -->
          <!-- ========================= -->

          <div *ngIf="selectedFile">

            <input class="form-control" type="text" [placeholder]="'CAPTION' | translate" [(ngModel)]="caption"
              [disabled]="uploading">


            <textarea class="form-control" [placeholder]="'DESCRIPTION' | translate" [(ngModel)]="description"
              [disabled]="uploading">
            </textarea>


            <!-- Progress -->
            <div *ngIf="uploading" class="progress mt-3">

              <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress">

                {{ uploadProgress }}%

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>


    <!-- ========================= -->
    <!-- Attachments -->
    <!-- ========================= -->

    <ng-container *ngFor="let item of attachment; let i = index">

      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4" *ngIf="
          item.deleted_by == '' ||
          (userRole && userRole.includes('ADMIN'))
        ">

        <div class="card">


          <!-- ========================= -->
          <!-- Attachment actions -->
          <!-- ========================= -->

          <div class="card-header">


            <!-- Delete -->
            <a *ngIf="!item.deleted_by" class="btn btn-outline-danger text-danger"
              (click)="deleteConfirm(item.newname)">

              <i class="fa fa-trash-o fa-lg"></i>

            </a>


            <!-- Restore -->
            <a *ngIf="
                item.deleted_by != '' &&
                userRole &&
                userRole.includes('ADMIN')
              " class="btn btn-outline-dark text-dark" (click)="restore(item.newname)">

              <i class="fa fa-undo fa-lg"></i>

            </a>


            <!-- Delete forever -->
            <a *ngIf="
                item.deleted_by != '' &&
                userRole &&
                userRole.includes('ADMIN')
              " class="btn btn-outline-danger text-danger" (click)="deleteConfirm(item.newname, 'ADMIN')">

              <i class="fa fa-trash-o fa-lg"></i>

            </a>


            <!-- Download -->
            <a class="btn btn-outline-primary text-primary" (click)="downloadFile(item.newname)">

              <i class="fa fa-download fa-lg"></i>

            </a>


            <!-- Open -->
            <a class="btn btn-outline-success text-success" [href]="
                url +
                'api/files/' +
                path +
                '/' +
                (pkey
                  ? (ref || selectedRows[pkey])
                  : selectedRows
                ) +
                '/' +
                item.newname +
                '?token=' +
                token
              " target="_blank">

              <i class="fa fa-eye fa-lg"></i>

            </a>

          </div>


          <!-- ========================= -->
          <!-- Attachment information -->
          <!-- ========================= -->

          <div class="card-body">

            <div>
              {{ 'CAPTION' | translate }}:
              {{ item.caption | translate }}
            </div>


            <div *ngIf="item.description">

              {{ 'DESCRIPTION' | translate }}:
              {{ item.description | translate }}

            </div>


            <div>

              {{ 'CREATED_BY' | translate }}:
              {{ item.created_by }}

            </div>


            <div *ngIf="
                userRole &&
                item.deleted_by &&
                userRole.includes('ADMIN')
              ">

              {{ 'DELETED_BY' | translate }}:
              {{ item.deleted_by }}

            </div>


            <div>

              {{ 'CREATED_AT' | translate }}:
              {{ item.created_at | dateformater: 1 }}

            </div>

          </div>

        </div>

      </div>

    </ng-container>

  </div>

</div>